import { Component } from '@angular/core';
import {PaneBackButtonComponent} from "../pane-back-button/pane-back-button.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Store} from "@ngrx/store";
import {ChatsService} from "../../services/chats.service";
import {Chat} from "../../state/chats/chat.model";

import * as ChatSelectors from "../../state/chats/chat.selector";
import {NgForOf} from "@angular/common";
import {ChatsBarChatItemComponent} from "../chats-bar-chat-list-item/chats-bar-chat-item.component";
import * as routeSelectors from "../../state/route/route.selector";
import {worldActions} from "../../state/world/world.actions";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'chats-bar',
  standalone: true,
    imports: [
        PaneBackButtonComponent,
        ReactiveFormsModule,
        FormsModule,
        NgForOf,
        ChatsBarChatItemComponent
    ],
  templateUrl: './chats-bar.component.html',
  styleUrl: './chats-bar.component.scss'
})
export class ChatsBarComponent {

    searchText: string = "";

    chats: Chat[]

    hovered = true

    constructor(
        private store: Store,
        private router: Router,
        private route: ActivatedRoute,
        private chatsService: ChatsService
    ) {
        this.store.select(ChatSelectors.selectAllChats).subscribe((chats) => {
            this.chats = chats
        })
    }

    setHovered(hovered: boolean) {
        this.hovered = hovered
    }


    trackById(index: number, item: any) {
        return item.id;
    }

    enterPressed(event) {

    }

    setSearchActive(active: boolean) {

    }

    openChat(chatId: string) {
        this.router.navigate(
            [{outlets: {'left-pane': "chat"}}],
            {
                queryParams: {
                    chatId: chatId,
                },
                queryParamsHandling: 'merge' // optional but common
            })
    }

}
